import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect: '/',
  // },
  {path: '/', component:  () => import( '../views/index/index.vue'), name: 'index', meta: {title: '首页', type: 'home'} },
  {path: '/aboutUs', component:  () =>import( '../views/aboutUs/index'), name: 'aboutUs', meta: {title: '关于我们', type: 'home'} },
  {path: '/contact', component:  () =>import( '../views/contact/index'), name: 'contact', meta: {title: '联系我们', type: 'home'} },
  {path: '/news', component:   () =>import( '../views/news/index'), name: 'news', meta: {title: '新闻', type: 'home'} },
  {path: '/productService', component:   () =>import( '../views/productService/index'), name: 'productService', meta: {title: '产品服务', type: 'home'} },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//防止相同路由重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  next()

  document.title = `长沙伊测电子科技有限公司 - ${to?.meta?.title}`

 
})
export default router
